module.exports = __webpack_public_path__ + "Images/dull-blue-circle.png";


//////////////////
// WEBPACK FOOTER
// ./app/insa-pivot/lib/simile-timeline/timeline_js/images/dull-blue-circle.png
// module id = 1864
// module chunks = 2